// extracted by mini-css-extract-plugin
module.exports = {"Box":"PetCard_Box__16Rl2","title":"PetCard_title__XGyn0","desc":"PetCard_desc__1YBjT","image":"PetCard_image__CRmK8"};